export enum AmplitudeEvent {
  qrCodeDownloaded = '[Web Administrator] QR Code Downloaded',
  homeViewed = '[Web Administrator] Home Viewed',
  accountStatusStarted = '[Web Administrator] Account Status Started',
  paymentMethodsAdded = '[Web Administrator] Payment Methods Added',
  expirationDateAdded = '[Web Administrator] Expiration Date Added',
  customerIdImported = '[Web Administrator] Customer ID Imported',
  unitsLinked = '[Web Administrator] Units Linked',
  customerLedgersImported = '[Web Administrator] Customer Ledgers Imported',
  activationEnded = '[Web Administrator] Activation Ended',
  accountStatusViewed = '[Web Administrator] Account Status Viewed',
  fileImported = '[Web Administrator] File Imported',
  paymentRequired = '[Web Administrator] Payment Required',
  communicationSelected = '[Web SuperAdmin] Communication Selected',
  imagesCommunicationsUpload = '[Web SuperAdmin] Images Communications Upload',
  multisessionsCreated = '[Web SuperAdmin] Multisessions created',
  noticesSelected = '[Web Administrator] Notices Selected',
  reservationSelected = '[Web Administrator] Reservation Selected',
  communicationsSended = '[Web SuperAdmin] Communications Sended',
  newNoticedCreated = '[Web Administrator] New Noticed Created',
  reservationCanceled = '[Web Administrator] Reservation Canceled',
  usersExcelDownloaded = '[Web Administrator] Excel Downloaded',
  accountingSystemSelected = '[Web Administrator] Accounting System Selected',
  unitCreated = '[Web Administrator] Unit Created',
  selectedNoticeMacroCommunity = '[Web Administrator] Macro Communities Notices Selected',
  createdNoticeMacroCommunity = '[Web Administrator] Macro Communities New Noticed Created',
  pqrsActivated = '[Web SuperAdmin] PQRS Activated',
  pqrsVisualized = '[Web Administrator] PQRS Visualized',
  pqrsStarted = '[Web Administrator] PQRS Started',
  pqrsUserReporterSelected = '[Web Administrator] User PQRS Reporter Selected',
  pqrsCreated = '[Web Administrator] PQRS Created',
  pqrsSettingsOpened = '[Web Administrator] PQRS Settings Opened',
  pqrsSettingsSaved = '[Web Administrator] PQRS Settings Saved',
  pqrsStatus = '[Web Administrator] PQRS Status',
  frequentAccessQrCodeActivated = '[Web SuperAdmin] Frecuent Access QR code Activated',
  frequentAccessAdminStarted = '[Web Administrator] Frecuent Access Admin Started',
  frequentAccessAdminCreated = '[Web Administrator] Frecuent Access Admin Created',
  uniqueAccessAdminStarted = '[Web Administrator] Unique Access Admin Started',
  uniqueAccessAdminCreated = '[Web Administrator] Unique Access Admin Created',
  uniqueAccessAdminDeleted = "[Web Administrator] Unique Access Admin Delete",
  fastPassAccessAdminStarted = '[Web Administrator] FastPass Access Admin Started',
  fastPassAccessAdminCreated = '[Web Administrator] FastPass Access Admin Created',
  fastPassAccessAdminDeleted = "[Web Administrator] FastPass Access Admin Delete",
  uniqueVehicleCreated = '[Web Administrator]  Unique Vehicle Registration Created',
  frequentAccessAdminModified = '[Web Administrator] Frecuent Access Admin Modified',
  frequentAccessAdminDeleted = '[Web Administrator] Frecuent Access Admin Deleted',
  frequentVehicleCreated = '[Web Administrator]  Frequent Vehicle Registration Created',
  timeExtendedVisit = '[Web SuperAdmin] Time Extended',
  kioskoCreatedRole = '[Web SuperAdmin] Kiosk Created',
  buildingCreated = '[Web SuperAdmin] Building Created',
  callsViewed = '[Web Admin] Call Consulted',
  callAudioDonwloaded = '[Web Admin] Audio Downloaded',
  callsReportDownloaded = '[Web Admin] Call Report Downloaded ',
  agoraUserPreregistration = "[Web Admin] User preregistration Agora Triggered",
  agoraUserCreation = "[Web Admin] User Created Agora Triggered",
  agoraWhatsappSent = "[Web Admin] Whatsapp Agora Triggered",
  transactionReportDownloaded = '[Web Administrator] Transaction report download',
  transactionReportGenerated = '[Web Administrator] Transaction report download generated',
  singleAccessStarted = "[Web vigilant] single access started",
  singleAcesssSelectedType = "[Web vigilant] single access visit type selected",
  singleAccessFacialRecognitionCompleted = "[Web vigilant] single access face ID completed",
  singleAccessPreviouslyRegisteredPerson = "[Web vigilant] single access person details completed",
  singleAccessVehicleDataCompleted = "[Web vigilant] single access vehicle details completed",
  singleAccessCreated = "[Web vigilant] single access created",
  accessManagementFiltersApplied = "[Web Vigilant] Access management - Filters applied",
  accessManagemenVisitTypeFilterSelected = "[Web Vigilant] Access management - Visit type filter selected",
  accessManagementStatusFilterSelected = "[Web Vigilant] Access management - Access status filter selected",
  accessManagementInvitationDetailViewed = "[Web Vigilant] Access management - Invitation detail viewed",
  securityCenterFiltersApplied = "[Web Vigilant] Security Center - Filters applied",
  securityCenterVisitTypeFilterSelected = "[Web Vigilant] Security Center - Visit type filter selected",
  securityCenterDisplacementStatusSelected = "[Web Vigilant] Security Center - Displacement status filter selected",
  securityCenterInvitationDetailViewed = "[Web Vigilant] Security Center - Invitation detail viewed",
  facialRecognitionTermsConditions = '[Web Assistant] T&C Facial Recognition Accepted',
  faceRegistrationStarted = '[Web Assistant] Face Registration Started',
  incompleteRegistration = '[Web Assistant] Incomplete Registration',
  succesfulFaceRegistration = '[Web Assistant] Succesful Face Registration',
  unsuccesfulFaceRegistration = '[Web Assistant] Unsuccesful Face Registration',
  reservationCreated = '[Web Administrator] Reservations Created',
  accessExcelDownloaded = '[Web Administrator] Access Excel Downloaded',
  accessExcelUploaded = '[Web Administrator] Access Excel Upload',
  accountingDashboardViewed = '[Dash JD] Accounting Dashboard Viewed',
  graphDataInteracted = '[Dash JD] Graph Data Interacted',
  graphFilterApplied = '[Dash JD] Graph Filter Applied',
  forgotPasswordClicked = 'forgot_password_clicked',
  sendButtonClicked = 'send_button_clicked'
}

/**
 * Ticket management events (VDS-2933), aligned to Munily Event Template V2:
 * snake_case, English, object_action. Frontend-emitted (admin dashboard); the
 * backend emits ticket_created/assigned/first_responded/status_changed.
 * Sent via AmplitudeService.trackEvent (not the legacy enum-typed path).
 */
export enum TicketAnalyticsEvent {
  ticketCreationStarted = 'ticket_creation_started',
  ticketCreationReporterCompleted = 'ticket_creation_reporter_completed',
  ticketCreationDescriptionCompleted = 'ticket_creation_description_completed',
  ticketDetailViewed = 'ticket_detail_viewed',
  ticketViewChanged = 'ticket_view_changed',
  ticketReportAiSummaryRegenerated = 'ticket_report_ai_summary_regenerated',
  ticketReportBuilderOpened = 'ticket_report_builder_opened',
  ticketReportGenerated = 'ticket_report_generated',
}

/**
 * Areas v2 admin events (VDS-3353). Frontend-emitted after successful BE
 * confirmation. Property keys follow the product spreadsheet (`Area name`,
 * `Parameter name`, `community_type`).
 */
export enum AreaAnalyticsEvent {
  commonAreaCreated = 'common_area_created',
  commonAreaUpdated = 'common_area_updated',
}

/**
 * Reservations v2 admin events (VDS-3448). Event names follow the product
 * spreadsheet (including known typos: resevation_*, payment_proof_delated).
 * Frontend-emitted via AmplitudeService.trackEvent after the trigger succeeds
 * (UI for started/filter; BE success for create/consult/update/proof/report).
 */
export enum ReservationAnalyticsEvent {
  reservationStarted = 'reservation_started',
  reservationCreated = 'reservation_created',
  /** Spreadsheet spelling (typo). */
  reservationConsulted = 'resevation_consulted',
  paymentProofAttached = 'payment_proof_attached',
  /** Spreadsheet spelling (typo). */
  paymentProofDeleted = 'payment_proof_delated',
  reservationUpdated = 'reservation_updated',
  reportDownloaded = 'report_downloaded',
  /** Spreadsheet spelling (typo). */
  reservationFilterApplied = 'resevation_filter_applied',
}

export class AmplitudeGenericEvent {
  event_type: AmplitudeEvent;
  user_id: string;
  event_properties?:
    | CustomerLedgersImported
    | FileImported
    | CustomerIdImported
    | PaymentRequired
    | QrCodeDownloaded
    | CommunicationsSended
    | NewNoticedCreated
    | NewNoticedCreated
    | ReservationSelected
    | CommunicationSelected
    | NoticesSelected
    | CreatedNoticeMacroCommunity
    | MultisessionsCreated
    | AccountingSystemSelected
    | CreatedNoticeMacroCommunity
    | CheckBoxEnabled
    | StatusChangedPQRS
    | UserRol
    | createPQRS
    | extendVisitTime
    | createdKioskoRol
    | BuildingCreated
    | TransactionReportDownloaded
    | SingleAcesssSelectedType
    | SingleAccessPreviouslyRegisteredPerson
    | SingleAccessCreated
    | AccessMannagementFiltered
    | AccessManagemenVisitTypeFilterSelected
    | AccessManagementStatusFilterSelected
    | SecurityCenterFiltered
    | SecurityCenterVisitTypeFilterSelected
    | SecurityCenterDisplacementStatusFilterSelected
    | FacialRecognitionTermsConditions
    | FaceRegistrationStarted
    | IncompleteRegistration
    | SuccesfulFaceRegistration
    | UnsuccesfulFaceRegistration
    | ReservationCreated
    | AccessExcelUploaded
    | UsersExcelDownloaded
    | AccountingDashboardViewed
    | GraphDataInteracted
}

export class CustomerLedgersImported {
  'Import State': ImportStatus;
}

export class FileImported {
  'Import State': ImportStatus;
}

export class CustomerIdImported {
  'Import State': ImportStatus;
}

export enum ImportStatus {
  successful = 'Successful',
  failed = 'Failed',
}

export class PaymentRequired {
  'Users Up to Day': string;
  'Debtors 1 To 30 Days': string;
  'Debtors 30 To 60 Days': string;
  'Debtors 60 Days': string;
}

export class QrCodeDownloaded {
  'Download State': DownloadStatus;
}

export enum DownloadStatus {
  successful = 'true',
  failed = 'false',
}

export class CommunicationSelected {
  'Action Communications Type': ActionCommunicationsType;
}

export enum ActionCommunicationsType {
  new = 'New',
  modify = 'Modify',
  delete = 'Delete',
}

export class MultisessionsCreated {
  'PH Name': string;
}

export class CommunicationsSended {
  'Type Notification Communications': TypeNotification;
  'Subject Communications': string;
}

export enum TypeNotification {
  both = 'Both',
  email = 'Email',
  notificationPush = 'Notification Push',
}

export class NewNoticedCreated {
  'User Notices Selected': String;
}

export class ReservationSelected {
  'Response Admin Type': string;
}
export class NoticesSelected {
  'Action Notices Type': ActionNoticesType | string;
}

export enum ActionNoticesType {
  pdf = 'PDF',
}

export enum AccountingSystems {
  sage50 = "Sage50",
  other = "Other"
}

export class AccountingSystemSelected {
  'System Type': AccountingSystems;
}

export class CreatedNoticeMacroCommunity {
  'Subject News': string;
  'Group Name': string;
}
export class CheckBoxEnabled {
  'Checkbox Enabled': boolean;
}

export enum StatusPQRS {
  pending = 'Pendiente',
  inProgress = 'En Curso',
  expired = 'Vencida',
  solved = 'Resuelta',
}

export class StatusChangedPQRS {
  'PQRS status': StatusPQRS;
}

export class UserRol {
  'User rol': string;
}

export enum categoriesPQRS {
  request = 'Petición',
  claim = 'Reclamo',
  complain = 'Queja',
  suggestion = 'Sugerencia',
}

export class createPQRS {
  'PQRS Category': categoriesPQRS;
  'PQRS Title': string;
}

export class extendVisitTime {
  'Subject Time Extended': string
}

export class createdKioskoRol {
  'Name Kiosk': string
}

export class BuildingCreated {
  'PH Name': string;
  'Creation Date': string;
}

//Single Access ↓↓↓↓↓↓↓↓↓
export class SingleAcesssSelectedType {
  'Visit Type': string;
}
export class SingleAccessPreviouslyRegisteredPerson {
  'Registered Data': boolean;
}

export class SingleAccessCreated {
  'Vehicle Type': string;
}
//Single Access ↑↑↑↑↑↑↑↑↑

//Access Mannagement ↓↓↓↓↓↓↓↓↓
export enum AccessMannagementFilters {
  name = 'Nombre',
  plate = 'Placa',
  local = 'Local',
  visitType = 'Tipo de visitante',
  accessStatus = 'Estado del acceso'
}

export class AccessMannagementFiltered {
  'Filters': AccessMannagementFilters[];
}

export enum AccessMannagementVisitType {
  COLLABORATOR = 'Colaborador',
  VISIT = 'Visitante',
  PROVIDER = 'Proveedor',
  GUEST = 'Huésped',
  DELIVERY = 'Delivery',
  PACKAGE = 'Paquete'
}

export class AccessManagemenVisitTypeFilterSelected {
  'Visit type': AccessMannagementVisitType;
}

export enum AccessMannagementAccessStatus {
  ACTIVE = 'Activo',
  DELETED = 'Eliminado',
  EXPIRED = 'Vencido',
  COMPLETED = 'Completado'
}

export class AccessManagementStatusFilterSelected {
  'Access status': AccessMannagementAccessStatus;
}
//Access Mannagement ↑↑↑↑↑↑↑↑↑

//Security Center ↓↓↓↓↓↓↓↓↓
export enum SecurityCenterFilters {
  search = 'Busqueda',
  unit = 'Local',
  type = 'Tipo de visitante',
  status = 'Estado del recorrido',
  lastMark = 'Última marcación'
}

export class SecurityCenterFiltered {
  'Filters': SecurityCenterFilters[];
}

export class SecurityCenterVisitTypeFilterSelected {
  'Visit type': AccessMannagementVisitType;
}

export enum SecurityCenterDisplacementStatus {
  active = 'Entró',
  displacement = 'Desplazamiento',
  completed = 'Salió',
  'completed-by-system' = 'No salió',
  'time-exceeded' = 'Tiempo excedido'
}

export class SecurityCenterDisplacementStatusFilterSelected {
  'Displacement status': SecurityCenterDisplacementStatus[];
}
//Security Center ↑↑↑↑↑↑↑↑↑

export class TransactionReportDownloaded {
  'generation State': 'Successful' | 'Failed';
}

export enum Platform {
  assistant = 'Link de invitación',
  app = "App",
  dashboardAdmin = "Dashboard del admin",
  dashboardVigilant = "Dashboard del guardia"
}

export enum RecognitionUsersRol {
  tenant = 'Residente',
  proprietor = 'Propietario',
  admin = 'Administrador',
  biometric = 'Usuario biométrico'
}

export enum ScanType {
  resisdent = 'Residente',
  visit = 'Visita'
}

export enum VisitType {
  collaborator = 'Colaborador',
  visit = 'Visitante',
  delivery = "Delivery",
  provider = "Proveedor",
  guest = "Huesped",
  package = "Paquete"
}

export class RecognizingGenericEvent {
  'Tipo de Escaneo': ScanType;
  'Rol'?: RecognitionUsersRol;
  'Tipo de Visita': VisitType;
  'Plataforma': Platform;
}

export class FacialRecognitionTermsConditions extends RecognizingGenericEvent { }
export class FaceRegistrationStarted extends RecognizingGenericEvent { }
export class SuccesfulFaceRegistration extends RecognizingGenericEvent { }
export class IncompleteRegistration extends RecognizingGenericEvent {
  'Continue': boolean;
}
export class UnsuccesfulFaceRegistration {
  'imageCaptured'?: boolean;
  'blinkedTimes'?: number;
  'partialPassed'?: boolean;
  'texturesScores'?: string;
  'texturesPassed'?: boolean;
  'brightnessScores'?: string;
  'brightnessPassed'?: boolean;
  'generalPassed'?: boolean;
  'pupilVariationPassed'?: boolean;
  'mouthVariationPassed'?: boolean;
  'pupilVariation'?: number;
  'mouthVariation'?: number;
}

export enum VehicleType {
  car = 'Carro',
  motorcycle = 'Moto',
  other = 'Otro'
}

export class ReservationCreated {
  'Area Name': string;
  'Nested Resources': boolean;
  'Nested Resources name': string;
  'Unit Name': string;
}

export enum StatusFile {
  successful = 'Import Successful',
  failed = 'Import Failed',
}

export class AccessExcelUploaded {
  'Status File': StatusFile;
  'Massive access created': number;
  'Failed entries': number;
}

/** VDS-3445 — users module Excel download (`[Web Administrator] Excel Downloaded`). */
export class UsersExcelDownloaded {
  'PH ID': string;
  'PH Name': string;
}

export class AccountingDashboardViewedBasic {
  'User name': string;
  'User Type': string;
  'PH Name': string;
}

export enum AccountingDashboardTypeAccess {
  WEB = 'Web Access',
  APP = 'App Access',
}

export enum AccountingDashboardGraphType {
  facturadoVsCobradoQty = 'Grafica facturado vs cobrado (Qty)',
  providerExpensesDistribution = 'Grafica distribución pagos a proveedores',
  accountExpensesDistribution = 'Grafica distribución pagos por cuenta',
  incomeVsExpenses = 'Grafica ingresos vs egresos',
}
export class AccountingDashboardViewed {
  'Type Access': AccountingDashboardTypeAccess;
}

export class GraphDataInteracted {
  'Graph Name': AccountingDashboardGraphType;
  'Type Access': AccountingDashboardTypeAccess;
  'Duration (ms)': number;
}

export const NOT_APPLY = 'NOT_APPLY';
